import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

const OlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ol" sx={styles}>
    {children}
  </Box>
);

export default OlList;
